module.exports = __webpack_public_path__ + "img/building-light.cc833d71.svg";